var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("textarea", {
    directives: [
      {
        name: "model",
        rawName: "v-model",
        value: _vm.content,
        expression: "content",
      },
    ],
    ref: "textarea",
    attrs: {
      name: _vm.name,
    },
    domProps: {
      value: _vm.content,
    },
    on: {
      input: function input($event) {
        if ($event.target.composing) return
        _vm.content = $event.target.value
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }